var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SDatepickerBase',_vm._g(_vm._b({attrs:{"value":_vm.value,"is-valid":_vm.isValid,"has-warning":_vm.hasWarning,"error-messages":_vm.errorMessages}},'SDatepickerBase',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }